import { byUserInteraction, sendGoogleEvent } from '@html/_common/utils';

export default function AOSerpTourTags() {
  const TAG_CLASS = '.js-ao-serp-tour-tags__tag';
  const INFOBOX_CLASS = '.js-ao-serp-tour-tags__infobox';
  const trackingCategory = 'SERP';
  let isHovered = false;

  this.initiate = () => {
    if ($(TAG_CLASS).length === 0) {
      return;
    }

    byUserInteraction('initiate-info-box', this.initiateInfobox);
  };

  this.initiateInfobox = () => {
    if ($(INFOBOX_CLASS).length === 0) {
      return;
    }

    $('body').on('mouseover', TAG_CLASS, (event) => {
      const $element = $(event.currentTarget);
      $element.find(INFOBOX_CLASS).removeClass('hid');
      const trackingAction = $element.data('ga-action');

      if (!isHovered) {
        sendGoogleEvent(
          `${trackingCategory}`,
          `${trackingAction}`,
          'On hover pop up',
        );

        isHovered = true;
      }
    }).on('mouseout', TAG_CLASS, (event) => {
      const $element = $(event.currentTarget);
      $element.find(INFOBOX_CLASS).addClass('hid');
    });
  };
}
